export const  INSURANCE  = {
  INSURANCE: 'INSURANCE',
  CLEAR: 'CLEAR',
}
